const trackMessage = (str) => {
  if (window && window.trackJs) {
    window.trackJs.track(str)
  }
  else {
    console.warn('TrackJS is not available, falling back to console.log')
    console.log(str)
  }
}
export default trackMessage
